import { responsiveVariables } from "../../../utilities/props.js";
import "./aspectRatio.css";
const aspectRatio = (value) => {
    if (!value)
        return {};
    return {
        variables: responsiveVariables("--rs-ratio", value),
    };
};
export default aspectRatio;
